import { FC } from 'react';
import { ScheduledRefundDetail } from './ScheduledRefundDetail/ScheduledRefundDetail';

export const ScheduledRefundDetailPage: FC = () => {
  return <ScheduledRefundDetail />;
};
